export enum StageStatus {
  Passed = 'PASSED',
  Current = 'CURRENT',
  Future = 'FUTURE',
  Viewed = 'VIEWED',
}

export enum BpfCloseReasonType {
  Lost = 'LOST',
  Won = 'WON',
}

export type StagesViewType = 'all' | 'active';

export type TemplateConstructorMode = 'create' | 'edit' | 'copy';

export type BPFAPINameSpase<Response> = { bpf: Response };

export enum RecipientRole {
  SALES_MANAGER = 'SALES_MANAGER',
  SALES_REP = 'SALES_REP',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
}

export type Recipient = {
  userProfileId?: string;
  role?: RecipientRole;
  name: string;
};

export interface ViewSettings {
  showInactive: boolean;
}
